export default {
  reset: {
    header: {
      notes: 'Reset counter section header',
      message: 'Reset time to maintenance counter',
    },
    params: {
      workHours: {
        notes: 'Work hours param title',
        message: 'Work hours at time of activity',
      },
      timeToMaintenance: {
        notes: 'Time to maintenance param title',
        message: 'Time to maintenance at time of activity',
      },
    },
    resetDialog: {
      title: {
        notes: 'Reset dialog title',
        message: 'Reset counter',
      },
      content: {
        notes: 'Reset dialog content',
        message:
          'Are you sure you want to reset the time to maintenance counter?',
      },
    },
    resetStatusText: {
      notes: 'Text to show when counter will be reset',
      message: 'The counter will be reset',
    },
    resetButtonText: {
      notes: 'Title of reset button',
      message: 'Reset counter',
    },
  },
  activityTabs: {
    tasks: {
      notes: 'Header for tab Tasks',
      message: 'Tasks',
    },
    generalinfo: {
      notes: 'Header for tab General Information',
      message: 'General Information',
    },
    report: {
      notes: 'Header for tab Report',
      message: 'Report',
    },
  },
};
